export default {
    namespaced: true,
    state: {
        docs: [],
        error: null
    },
    mutations: {
        SET_DOCS(state, docs) {
            state.docs = docs
        },
        SET_ERROR(state, error) {
            state.error = error
        }
    },
    actions: {
        async getDocs({ commit }, user_id) {
            commit('SET_ERROR', null)
            const url = `user/documents?user_id=${user_id}`

            try {
                const resp = await this.$axios.get(url)

                commit('SET_DOCS', resp.data.documents)
            } catch (e) {
                console.log('Ошибка ' + e.message)
            }
        },
        async uploadDocument({ commit, dispatch }, form) {
            commit('SET_ERROR', null)
            const url = '/user/update-document'

            try {
                const resp = await this.$axios.post(url, form)
            } catch (e) {
                commit('SET_ERROR', e.response.data.error)
                console.log('Ошибка ' + e.message)
            }
        },
        async removeDocument({ commit, dispatch }, id) {
            commit('SET_ERROR', null)
            const url = `/user/delete-document?document_id=${id}`

            try {
                const resp = await this.$axios.delete(url)
            } catch (e) {
                commit('SET_ERROR', e.response.data.error)
                console.log('Ошибка ' + e.message)
            }
        }
    }
}
